import {fetchRequestSend, sendEventToAnalytics} from "../../helpers/common-helpers";
import PopupClass from "../common/PopupClass";

const handleToken = () => {
    let sso_login_button = document.querySelectorAll('.sso-login');
    if(!sso_login_button) return;
    sso_login_button.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            let type = button.dataset.provider;
            let url = '';
            switch(type){
                case 'google':
                     url = googleSignIn;
                    break;
                case 'microsoft':
                     url = microsoftSignIn;
                    break;
                default:
                     url = '';
                    break;
            }
            let data = '';
            fetchRequestSend(url, 'POST', data).then(response => {
                console.log(response);
                //debugger;
                if(response.status){
                    sessionStorage.setItem('oauth_type', 'true');

                    // sendBeacon so the event survives the redirect below.
                    sendEventToAnalytics('submit_form_login', {}, { transport: 'sendBeacon' });

                    if(response.data.login){
                        setTimeout(() => {
                            window.location.href = response.data.redirect;
                        }, 2000);
                    }
                    else{
                        //console.log(response);
                        //debugger;
                        sessionStorage.setItem('sso_signup','true');
                        window.location.href = response.data.redirect;
                    }
                }
                else{
                    if(response.data.error){
                        let errorMsg = document.getElementById('errorMessage');
                        errorMsg.style.display = 'block';
                        errorMsg.innerHTML = response.data.error;
                        setTimeout(() => {
                            errorMsg.style.display = 'none';
                        }, 2000);
                    }
                }
            });
        });
    });
}
const ssoSignUp = () => {
	//return true;
	// let preferredCountries =  ['United States','US','Canada','CA','UK','GB','United Kingdom','Ireland','IE','Australia','AU','New Zealand','NZ'];
	// if(!userCountry || preferredCountries.includes(userCountry)){
		showPopup('sso-free_signup-popup');
	//}
}

const showPopup = (popupId) => {
    let popup = new PopupClass();
    popup.open(popupId);
}
const showDataModal = (response) => {

	console.log(response);
	let modalId = document.getElementById('sso_login_data');
	let captured_data = document.getElementById('captured_data');
	let api_data = document.getElementById('sso_data');
	modalId.style.zIndex = '1055';
	$(modalId).modal('show');
	let html = '';
	let data = response.data.info;
	Object.keys(data).forEach(key=>{
		console.log(key);
		console.log(data[key]);

		html+='<div id='+key+'><label>'+key+' => '+data[key]+'</label></div>'
		if(key=='name'){
			captured_data.innerHTML +='<div id=captured_data_'+key+'><label>'+key+' => '+data[key]+'</label></div>';
		}
		if(key=='email'){
			captured_data.innerHTML +='<div id=captured_data_'+key+'><label>'+key+' => '+data[key]+'</label></div>';
		}
		if(key=='picture'){
			captured_data.innerHTML +='<div id=captured_data_'+key+'><label>'+key+' => '+data[key]+'</label></div>';
		}
	})
	api_data.innerHTML = html;
}

// export all functions
export {
    handleToken,
    ssoSignUp,
    showDataModal,
};
